import { createTheme } from '@mui/material/styles';
import colors from './colors';

//Enlace a la documentacion: https://mui.com/material-ui/customization/theming/#createtheme-options-theme
//TODO root enlaces a color primary

export const appTheme = createTheme({
    palette: {
        type: 'light',
        primary: {
            main: colors.primary,
        },
        secondary: {
            main: colors.secondary,
        },
        text: {
            main: colors.textMain,
            link: colors.textMain,
            black: colors.parrafos,
        },
        error: {
            main: colors.error
        },
    },
    //TODO indicar para que sirve cada comp o variant y cambiar nombres a mas facil de identificar
    typography: {
        fontFamily: 'Montserrat, sans-serif',
        //Titulo unico por cada página
        tituloModal: {
            fontSize: '1.25em',
            color: colors.parrafos,
            fontWeight: "bold"
        },
        parrafo: {
            color: colors.parrafos,
            fontSize: '1em',
            lineHeight: '1.5',
        },
        parrafoLight: {
            color: colors.textMain,
            fontSize: '1em',
            lineHeight: '1.5',
        },
        parrafoPrimary: {
            color: colors.primary,
            fontSize: '1em',
            lineHeight: '1.5',
        },
        enlaceHeader: {
            color: colors.textMain,
            fontSize: '1.2em',
        },
        parrafoFooter: {
            margin: 0,
            fontWeight: "400",
            fontSize: "0.8em",
            color: colors.primary
        },

    },
    components: {
        MuiTypography: {
            variants:
                [
                    {
                        //Todas las páginas deben tener uno
                        props: { variant: 'h1' },
                        style: {
                            color: colors.primary,
                            fontSize: "2.2em",
                            textAlign: "center",
                            margin: "2em 0",
                        },
                    },
                    {
                        //Organizaremos los bloques de contenidos con h2
                        props: { variant: 'h2' },
                        style: {
                            fontSize: '1.5em',
                            color: colors.primary,
                            marginTop: "1em",
                            textAlign: "justify",
                        },
                    },
                    {
                        //Usaremos estos dentro de los bloques h2 de forma jerarquica
                        props: { variant: 'h3' },
                        style: {
                            fontSize: '1.3em',
                            color: colors.primary,
                        },
                    },
                    {
                        props: { variant: 'h4' },
                        style: {
                            fontSize: '1.2em',
                            color: colors.primary
                        },
                    },
                    {
                        props: { variant: 'h5' },
                        style: {
                            fontSize: '1.1em',
                            color: colors.primary
                        },
                    },
                ],
        },
        MuiSelect: {
            variants:
                [
                    {
                        props: { variant: 'filled' },
                        style: {
                            color: 'white',
                            backgroundColor: colors.primary,
                            border: 0
                        },
                    },
                ],
        },
        //TODO color label checkbox
        MuiCheckbox: {
            styleOverrides: {
                root: {
                    color: colors.primary,
                },
            },
        },
        MuiFormControlLabel: {
            styleOverrides: {
                label: {
                    color: colors.parrafo,
                },
            },
        },
        MuiButton: {
            variants: [
                {
                    props: { variant: 'contained' },
                    style: {
                        transition: '0.6s ease',
                        '&:hover': {
                            transform: 'scale(1.02)'
                        },
                        color: colors.textMain,
                        borderRadius: '1em',
                        padding: '1em',
                        fontWeight: 'bold'
                    }
                },
                {
                    props: { variant: 'outlined' },
                    style: {
                        transition: '0.6s ease',
                        '&:hover': {
                            backgroundColor: colors.textMain,
                            color: colors.primary,
                            transform: 'scale(1.02)'
                        },
                        borderColor: colors.textMain,
                        color: colors.textMain,
                        borderRadius: '1em',
                        padding: '1em',
                        fontWeight: 'bold'
                    }
                }
            ]
        },
        MuiFormLabel: {
            variants: [
                {
                    props: { variant: 'radioLabel' },
                    style: {
                        color: colors.parrafos, // Cambia el color a tu preferencia
                        fontSize: '1.2em', // Cambia el tamaño de fuente a tu preferencia
                        // Añade aquí otros estilos personalizados según tus necesidades
                    },
                },
            ],
        },
        MuiRadio: {
            styleOverrides: {
                label: {
                    color: 'red', // Cambia el color a tu preferencia
                    // Añade aquí otros estilos personalizados según tus necesidades
                },
            },
        },
        MuiAutocomplete: {
            styleOverrides: {
                // Estilos para los textos en el desplegable
                option: {
                    color: colors.parrafo,
                    // Añade aquí otros estilos personalizados según tus necesidades
                },
                // Estilos para el texto seleccionado
                popper: {
                    '& .MuiAutocomplete-option[data-focus="true"]': {
                        backgroundColor: colors.primary,
                        color: colors.textMain,
                    },
                },
                clearIndicator: {
                    '&.MuiAutocomplete-clearIndicator': {
                        // Agrega aquí los estilos que deseas aplicar al elemento clearIndicator
                        color: colors.textMain,
                        backgroundColor: colors.primary
                    },
                    '& .MuiSvgIcon-root': {
                        color: colors.textMain, //Color de el icono dentro del clear de muiautocomplete
                    },
                },
                clearIndicator: {
                    '&.MuiAutocomplete-clearIndicator': {
                        // Agrega aquí los estilos que deseas aplicar al elemento clearIndicator
                        color: colors.textMain,
                        backgroundColor: colors.primary
                    },
                    '& .MuiSvgIcon-root': {
                        color: colors.textMain, //Color de el icono dentro del clear de muiautocomplete
                    },
                },
            }
        },
        MuiLink: {
            variants: [
                {
                    //Creo una nueva variante
                    props: { variant: 'linkFooter' },
                    style: {
                        margin: 0,
                        fontWeight: "400",
                        fontSize: "0.8rem",
                        color: colors.primary
                    },
                },
                {
                    // Listas de links
                    // Meter icono a una variant
                    props: { variant: 'listaLink' },
                    style: {
                        fontSize: "1.3rem",
                        color: colors.primary,
                        textDecoration: 'none',
                        lineHeight: "1.5",
                        '&:hover': {
                            textDecoration: 'underline',
                        },
                    }
                },
            ],
        },
        MuiSvgIcon: {
            styleOverrides: {
                root: {
                    color: colors.primary, // con sx={{color: colors.primary}} podemos darle a iconos en concreto
                },
            },
        },
        MuiBox: {
            variants: [
                {
                    //Creo una nueva variante
                    props: { variant: 'BorderRadius' },
                    style: {
                        borderRadius: '8px'
                    },
                },
            ]
        },
        MuiAccordion: {
            styleOverrides: {
                root: {
                    borderTopLeftRadius: '1rem !important',
                    borderTopRightRadius: '1rem !important',
                    borderBottomLeftRadius: '1rem !important',
                    borderBottomRightRadius: '1rem !important',
                },
            },
            variants: [
                {
                    props: { variant: 'GeneralAccordion' },
                    style: {
                        webkitBoxShadow: '0px 0px 2px 0px rgba(0,0,0,0.75)',
                        mozBoxShadow: '0px 0px 2px 0px rgba(0,0,0,0.75)',
                        boxShadow: '0px 0px 2px 0px rgba(0,0,0,0.75)',
                        '&:before': {
                            display: 'none',
                        }
                    },
                },
            ]
        }
        // TODO IconButton, tooltipbutton, loadingButton (gran parte en /Ejes) unificar y crear sus estilos aquí
    },
});

